import { FC, Suspense, useEffect } from 'react';
import { SingleUnitSkillProgressQuery } from '../../graphQLOperations/__generated__/SingleUnitSkillProgressQuery.graphql';
import { SkillsByType } from '../../models/SingleUnit';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { getSkillProgress } from '../../graphQLOperations/SingleUnit';
import { TargetSkillTypeLabel } from '../../models/TargetSkillType';
import { SkillAncestries, SkillAncestriesId } from '../../models/SkillAncestries';
import { Skill } from '../../models/Skill';
import { UsersBySkillResults } from '../../models/UsersBySkillResults';
import SingleUnitRightColumn from './SingleUnitRightColumn';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';
interface Props {
  queryReference?: PreloadedQuery<SingleUnitSkillProgressQuery> | unknown;
  skillsInUnit?: SkillsByType[];
  setSkillsInUnit: (s: SkillsByType[]) => void;
  keyProp: number;
  setClassWithoutStudent: (c: boolean) => void;
  targetSkillsIds: string[];
  selectedStandardIds?: string[];
  optionalFiltersApplied?: boolean;
}

const SingleUnitRightColumnWithProgress: FC<Props> = ({
  queryReference,
  skillsInUnit,
  setSkillsInUnit,
  keyProp,
  setClassWithoutStudent,
  targetSkillsIds,
  selectedStandardIds,
  optionalFiltersApplied,
}) => {
  const queryData = usePreloadedQuery<SingleUnitSkillProgressQuery>(
    getSkillProgress,
    queryReference as PreloadedQuery<SingleUnitSkillProgressQuery>,
  );

  useEffect(() => {
    const skillWithResults = skillsInUnit?.map(a => {
      const updatedSkills = a.skills.map(element => {
        const updatedElement = { ...element };
        if (a.targetSkillType === TargetSkillTypeLabel.TARGET) {
          const updatedSkillAncestries: SkillAncestries[] = [];

          updatedElement.skillAncestries?.forEach(b => {
            const progressBarDataForAncestriesSkill = queryData?.skillProgress.filter(
              el => el.skill.id === b.ancestorSkill.id,
            );

            let ancestorSkillWithResults;
            if (
              progressBarDataForAncestriesSkill &&
              progressBarDataForAncestriesSkill?.length > 0 &&
              b.skillRelevance.id !== SkillAncestriesId.LOW
            ) {
              ancestorSkillWithResults = {
                ...b.ancestorSkill,
                usersBySkillResults: progressBarDataForAncestriesSkill[0]?.usersBySkillResults,
              };
            } else {
              ancestorSkillWithResults = { ...b.ancestorSkill, usersBySkillResults: [] };
            }
            updatedSkillAncestries.push({ ...b, ancestorSkill: ancestorSkillWithResults as Skill });
          });

          updatedElement.skillAncestries = updatedSkillAncestries;
        }

        const progressBarDataForSkillId = queryData?.skillProgress.filter(el => el.skill.id === updatedElement.id);
        if (progressBarDataForSkillId) {
          updatedElement.usersBySkillResults = progressBarDataForSkillId[0]
            ?.usersBySkillResults as UsersBySkillResults[];
          return updatedElement;
        }
      });
      return { ...a, skills: updatedSkills };
    });

    let noStudents = true;
    queryData.skillProgress.forEach(el => {
      el.usersBySkillResults.forEach(e => {
        if (e.value.length > 0) return (noStudents = false);
      });
    });

    setClassWithoutStudent(noStudents);
    setSkillsInUnit(skillWithResults as SkillsByType[]);
  }, [queryData, keyProp]);

  return (
    queryData && (
      <Suspense fallback={<ThreeDotLoader />}>
        <SingleUnitRightColumn
          skillsInUnit={skillsInUnit}
          keyProp={keyProp}
          targetSkillsIds={targetSkillsIds}
          selectedStandardIds={selectedStandardIds}
          optionalFiltersApplied={optionalFiltersApplied}
        />
      </Suspense>
    )
  );
};

export default SingleUnitRightColumnWithProgress;
